import React, { Component } from 'react';

// Importing DataBase 
import { db } from '../../firebase/firebase';

// Styles
import './index.css';
import { Button, Container, Form , InputGroup } from 'react-bootstrap';

// getFullLocalTime
function getFullLocalTime() {
    const d = new Date();
    return d.toLocaleTimeString() + " " + d.toLocaleDateString();
}

// Main Footer Class
class Footer extends Component {
    state = { feedback: "" }

    onSubmit = event => {
        const { feedback } = this.state;
            db.ref('feedbacks').push().set(feedback)
            .then(()=> {
                this.setState({ feedback: "" });
                alert("Thank you so much for taking the time to send us your valuable feedback!");
            })
            .catch(e =>{
                alert(e.message);
            });
        event.preventDefault();
    }

    render() {
        const { feedback } = this.state;
        const Invalid = feedback === "";
        return (<>
            <hr/>
            <br/>
            <footer id="myFooter">
                <div className="container-foot">
                    <section className="ft-main">
                        <div className="ft-main-item">
                            <h2 className="ft-title">
                                ABOUT US
                            </h2>
                            <p className="main-p" style={{color: "white"}} >
                                    We are Code Mergers - group <br/>
                                    of student developers <br />
                            </p>
                        </div>
                        <div className="ft-main-item">
                        <h2 className="ft-title">CONTACT</h2>
                        <ul>
                            <li><a href="mailto:codemergers.org@gmail.com?subject=SmartClass User Mail%20&body=Hi," target="_top">Mail us</a></li>
                            <li><a href="https://github.com/Code-Mergers" 
                            target="_blank" rel="noreferrer">Code Mergers</a></li>
                        </ul>
                        </div>
                        <div className="ft-main-item footer-input">
                            <h2 className="ft-title">FEEDBACK</h2>
                            <p style={{color: "white"}}>Your feedback is valuable</p>
                            <Form onSubmit={this.onSubmit}>
                                <InputGroup style={{width: "75%"}}>
                                    <Form.Control id="feedback-text" type="textarea"
                                    name="feedback" placeholder="Write here..."
                                    value={feedback}
                                    onChange={(e)=> this.setState({feedback: e.target.value})
                                    }/>
                                </InputGroup>
                                <Button id="feedback-button" type="submit" disabled={Invalid}>Send</Button>
                            </Form>
                        </div>
                    </section>
                    <section className="ft-social">
                        <ul className="ft-social-list">
                            <li>
                                <a href="https://github.com/Code-Mergers" target="_blank" rel="noopener noreferrer">
                                    <i className="fa fa-github"></i>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.youtube.com/channel/UC1k3LQ8Cu7QGLGpt_YRS_Og" target="_blank" rel="noopener noreferrer">
                                    <i className="fa fa-youtube-play"></i>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.facebook.com/profile.php?id=100070570321423" target="_blank" rel="noopener noreferrer">
                                    <i className="fa fa-facebook"></i>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.linkedin.com/in/code-mergers-000674216/" target="_blank" rel="noopener noreferrer">
                                    <i className="fa fa-linkedin"></i>
                                </a>
                            </li>
                            <li>
                                <a href="https://twitter.com/CMergers" target="_blank" rel="noopener noreferrer">
                                    <i className="fa fa-twitter"></i>
                                </a>
                            </li>
                        </ul>
                    </section>
                    <section className="ft-legal">
                        <Container className="ft-legal-list" 
                        style={{color: "#888", width: "100%", display: "flex", justifyContent: "center" }}>
                            Copyright &copy; 2021 Code Mergers
                        </Container>
                    </section>
                </div>
            </footer>
        </>);
    }    
}

export default Footer;
export { getFullLocalTime };
